import React, { memo } from "react";
import { UncontrolledTooltip } from "reactstrap";
import AvailabilityDot from "../AvailabilityDot";

import "./style.scss";

function AgentInfo(props) {
  const { agent, availability, id, transf_user_id } = props.data;

  if (!agent || !agent.name) {
    return "-";
  }

  return (
    <div className="agent-info" title={agent.name}>
      {transf_user_id && <i className={`mdi mdi-share font-size-14 mr-1`} />}
      <AvailabilityDot data={availability} />
      <p id={`agent-${id}`}>{agent.name}</p>
      <UncontrolledTooltip placement="left" target={`agent-${id}`}>
        {agent.nickname}
      </UncontrolledTooltip>
    </div>
  );
}

export default memo(AgentInfo);
